
import AccountTenantServices from '../../../../Services/AccountTenantServices';
export function usedataProcessing($http,
	accountId,
	setpreviewTenant,
	// $rootScope,
	// $timeout,
	// $routeParams,
	AuthServices,
	// setAccountHasNoDatas,
	setlistTenantAccount
	) {
	const accountTenantServices = new AccountTenantServices($http,
		AuthServices, accountId
	);
	const sortByAsc = (a, b) => {

		if (a.label.toUpperCase() < b.label.toUpperCase()) return -1;
		if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
		return 0;

	};
	const getTenant = () => {
		accountTenantServices.getTenantsAccount(
			tenantL => {
				const listOfTenant = tenantL.map((tenant) => {
					if (tenant === '') {
						return {
							label: 'Default',
							value: tenant,
						};
					} else {
						return {
							label: tenant,
							value: tenant,
						};
					}
				});
				if (listOfTenant.length > 1) {
					listOfTenant.unshift({
						label: 'All',
						value: 'all'
					});
				}
				if (listOfTenant.length == 0){
					listOfTenant.push({
						label: 'Default',
						value: '',
					});
				}
				const listOfTenantSort = listOfTenant.sort(sortByAsc);
				if (listOfTenant.length == 0){
					listOfTenant.push({
						label: 'Default',
						value: ''
					});
				}
				setpreviewTenant(listOfTenantSort[0]);
				setlistTenantAccount(listOfTenantSort);
			},
			(_Error,errMessage) => {
				errMessage;

			}
		);};


	return {
		getTenant,
		sortByAsc
	};
}